import SystemFolderNode from "components/org-settings/org-shapefiles/SystemFolderNode";
import SystemRootNode from "components/org-settings/org-shapefiles/SystemRootNode";
import SystemShapefileNode from "components/org-settings/org-shapefiles/SystemShapefileNode";
import { ProjectTreeNodeT } from "components/project/layers/hooks";

type PromoteShapefileTreeNodeManagerPropsT = {
  node: ProjectTreeNodeT;
};

export function PromoteShapefileTreeNodeManager(
  props: PromoteShapefileTreeNodeManagerPropsT
) {
  const { node } = props;

  if (node.type === "root") {
    return <SystemRootNode node={node} hasActions={false} />;
  } else if (node.type === "shapefile") {
    return <SystemShapefileNode node={node} hasActions={false} />;
  } else if (node.type === "node") {
    return <SystemFolderNode node={node} hasActions={false} />;
  } else {
    return null;
  }
}
